import React, {useState} from 'react'
import '../css/components/AdminLogin.css';
import Logo from '../assets/hargharmart Logo.png';
import Loading from '../general/Loading'; 
import { useNavigate } from "react-router-dom";

const StaffLogin = ({setResponse}) => {
            const [formData, setFormData] = useState({
              mobile: '',
              pass: '',
            })
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
// const [showReset, setShowReset] = useState(false);

              // Handle form data change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  
  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent page reload

    setLoading(true);
    try {
      const response = await fetch('https://api.hargharmart.com/staff-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();
      console.log(data);
      if (response.ok) {
            setLoading(false);
          localStorage.setItem('userData', JSON.stringify(data));
          localStorage.setItem('isStaff', 'true');
              setResponse({ message: 'Login Successful.', status: 'success' });
          setTimeout(() => {
            setResponse('');
            navigate('/');
          }, 2000);
    }
      else {
          setLoading(false);
setResponse({
  message: data.message === 'Account does not exists. Signup first.' 
    ? 'Invalid Credentials' 
    : data.message,
  status: 'error'
});
      setTimeout(() => {
        setResponse('');
      }, 2000);
      }
    } catch (error) {
          setLoading(false);
      console.error('Error:', error);
    }
  };


  const handleResetPassword = async (e) => {
    e.preventDefault();

    setLoading(true);
    try {
      const response = await fetch(`https://api.hargharmart.com/reset-password`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();
      if (response.ok) {
    setLoading(false);
              setResponse({ message: result.message, status: 'success' });
          setTimeout(() => {
            setResponse('');
          }, 2000);
        //   setShowReset(false);
              } else {
    setLoading(false);
              setResponse({ message: result.message, status: 'error' });
          setTimeout(() => {
            setResponse('');
          }, 2000);
      }
    } catch (error) {
    setLoading(false);
      console.log(error);
    }
  };

  return (
    <>
      <section className='bg-light align-content-center vh-100'>
        <div className='container text-center col-lg-4 col-md-6'>

<div className='login-area'>
{/* <p className="fw-bold fs-2" style={{ color: "var(--blue)" }}>
  Satyam Kirana Store
</p> */}

    <img src={Logo} className='login-logo' alt='Header Logo' />

<p className='fm-spartan fs-4 fw-semibold mt-4'>Staff Login</p>

<form class="row g-3" onSubmit={handleSubmit}>
  <div class="col-12">
    <input type="tel" class="login-control" id="inputMobile4" name='mobile' maxLength='10' onChange={handleChange} value={formData.mobile} placeholder='Mobile Number' />
  </div>
  <div class="col-12">
    <input type="password" class="login-control" id="inputPassword4" name='pass' onChange={handleChange} value={formData.pass} placeholder='Your Password' />
  </div>

{/* <p className='text-danger fw-semibold para-text cursor-pointer' onClick={() => setShowReset(true)}>Forgot Password?</p> */}

  <div class="col-12 mt-3">
    <button type="submit" class="login-btn">Login Now</button>
  </div>
</form>
</div>

        </div>
      </section>

{loading && <Loading setLoading={setLoading} />}

      {/* {showReset && (
        <section className='detail-dialog px-3' onClick={() => setShowReset(false)}>
          <div className='detail-dialog-inner text-center rounded-4 col-lg-4 col-md-5 mx-auto py-5 px-5 animate__animated animate__backInUp' onClick={(e) => e.stopPropagation()}>

            <p className='page-title'>Reset Password</p>


            <form className="row g-3" onSubmit={handleResetPassword}>
              <div className="profile-input">
                <input
                  type="tel"
                  className="profile-control"
                  id="mobile"
                  name="mobile"
                  placeholder='Enter Mobile Number'
                  maxLength='10'
                  value={formData.mobile}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="profile-input">
                <input
                  type="pass"
                  className="profile-control"
                  id="pass"
                  name="pass"
                  placeholder='Enter New Password'
                  value={formData.pass}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-12 my-4">
                <button
                  className="close-btn"
                  onClick={() => setShowReset(false)}
                >
                  Cancel
                </button>
                &nbsp;&nbsp;
                <button type="submit" className="edit-btn">
                  Reset
                </button>
              </div>
            </form>
          </div>
        </section>
      )} */}
    </>
  )
}

export default StaffLogin
